import { render, staticRenderFns } from "./loyalty-rewards.vue?vue&type=template&id=d8a6a28e&scoped=true"
import script from "./loyalty-rewards.vue?vue&type=script&lang=js"
export * from "./loyalty-rewards.vue?vue&type=script&lang=js"
import style0 from "./loyalty-rewards.vue?vue&type=style&index=0&id=d8a6a28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a6a28e",
  null
  
)

export default component.exports